/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryLookupResponseDto } from './CategoryLookupResponseDto';
import {
    CategoryLookupResponseDtoFromJSON,
    CategoryLookupResponseDtoFromJSONTyped,
    CategoryLookupResponseDtoToJSON,
} from './CategoryLookupResponseDto';

/**
 * 
 * @export
 * @interface SubcategoryLookupResponseDto
 */
export interface SubcategoryLookupResponseDto {
    /**
     * Sub-category ID
     * @type {number}
     * @memberof SubcategoryLookupResponseDto
     */
    id: number;
    /**
     * Unique code for the sub-category
     * @type {string}
     * @memberof SubcategoryLookupResponseDto
     */
    code: string;
    /**
     * English name of the sub-category
     * @type {string}
     * @memberof SubcategoryLookupResponseDto
     */
    nameEn: string;
    /**
     * Arabic name of the sub-category
     * @type {string}
     * @memberof SubcategoryLookupResponseDto
     */
    nameAr?: string;
    /**
     * Description of the sub-category
     * @type {string}
     * @memberof SubcategoryLookupResponseDto
     */
    description?: string;
    /**
     * Parent category lookup ID
     * @type {number}
     * @memberof SubcategoryLookupResponseDto
     */
    categoryLookupId: number;
    /**
     * Sort order for display
     * @type {number}
     * @memberof SubcategoryLookupResponseDto
     */
    sortOrder?: number;
    /**
     * Whether the sub-category is active
     * @type {boolean}
     * @memberof SubcategoryLookupResponseDto
     */
    isActive: boolean;
    /**
     * Creation date
     * @type {Date}
     * @memberof SubcategoryLookupResponseDto
     */
    createdAt: Date;
    /**
     * Last update date
     * @type {Date}
     * @memberof SubcategoryLookupResponseDto
     */
    updatedAt: Date;
    /**
     * Parent category lookup details
     * @type {CategoryLookupResponseDto}
     * @memberof SubcategoryLookupResponseDto
     */
    categoryLookup?: CategoryLookupResponseDto;
}

/**
 * Check if a given object implements the SubcategoryLookupResponseDto interface.
 */
export function instanceOfSubcategoryLookupResponseDto(value: object): value is SubcategoryLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('categoryLookupId' in value) || value['categoryLookupId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SubcategoryLookupResponseDtoFromJSON(json: any): SubcategoryLookupResponseDto {
    return SubcategoryLookupResponseDtoFromJSONTyped(json, false);
}

export function SubcategoryLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubcategoryLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'description': json['description'] == null ? undefined : json['description'],
        'categoryLookupId': json['categoryLookupId'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'isActive': json['isActive'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'categoryLookup': json['categoryLookup'] == null ? undefined : CategoryLookupResponseDtoFromJSON(json['categoryLookup']),
    };
}

export function SubcategoryLookupResponseDtoToJSON(value?: SubcategoryLookupResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'categoryLookupId': value['categoryLookupId'],
        'sortOrder': value['sortOrder'],
        'isActive': value['isActive'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'categoryLookup': CategoryLookupResponseDtoToJSON(value['categoryLookup']),
    };
}

